/**
 * `#faq` — `template.html` dòng 1027–1039. Sáu mục, đúng thứ tự thiết kế.
 *
 * Khoá đặt tên `question`/`answer` **không phải** `q`/`a`: `jsonld.faqPage()` của `@nexa/seo` nhận
 * `readonly FaqItem[]` với đúng hai tên đó, nên trùng tên là truyền thẳng được, không cần một lớp
 * map trung gian chỉ để đổi tên khoá.
 *
 * Thứ tự sáu mục có nghĩa: mục cuối ("Khi nào có bảng giá chính thức?") trả lời đúng câu mà
 * `#pricing` ngay phía trên vừa bỏ ngỏ. Đảo thứ tự là cắt mạch đó.
 */
interface FaqEntry {
  readonly question: string;
  readonly answer: string;
}

export const faq = {
  heading: 'Câu hỏi thường gặp',
  items: [
    {
      question: 'Nexa có triển khai on-premise được không?',
      answer:
        'Có. Nexa chạy được ở dạng cloud quản lý, private cloud hoặc on-premise hoàn toàn với cùng bộ tính năng; NewEra Inc. hỗ trợ cài đặt và bàn giao vận hành.',
    },
    {
      question: 'Chúng tôi có phải chuyển đổi toàn bộ cùng lúc không?',
      answer:
        'Không. Phần lớn đội bắt đầu bằng chat trên vài channel, sau đó bật dần Project Manager và Knowledge Base.',
    },
    {
      question: 'Agent AI được đọc dữ liệu nào?',
      answer:
        'Đúng theo phạm vi của agent: Public Agent đọc các nguồn dùng chung, Agent phòng ban giới hạn theo whitelist, còn Alias Agent thừa hưởng đúng bằng quyền truy cập của nhân viên sở hữu nó.',
    },
    {
      question: 'Có ứng dụng di động không?',
      answer:
        'Có — bản mobile với điều hướng bottom-tab cho chat, topic, phê duyệt và task; toàn bộ workspace đầy đủ nằm ở bản web.',
    },
    {
      question: 'Giao diện hỗ trợ ngôn ngữ nào?',
      answer: 'Tiếng Việt và tiếng Anh, mỗi người dùng tự chọn.',
    },
    {
      question: 'Khi nào có bảng giá chính thức?',
      answer:
        'Các gói đang được hoàn thiện. Hãy liên hệ, chúng tôi sẽ báo giá bản chạy thử cho đội của bạn trước.',
    },
  ] as readonly FaqEntry[],
};
